export default __webpack_public_path__ + "static/media/HONEYDerma.54224b62.png";